import { PageListDataSource, PageListCachedDataSource } from './BaseDataSources';
import { IFastBuyPackageList } from '../Interfaces';
import { IEntityData } from '@samc/taskmanagement-ui';

export class PackageSource extends PageListDataSource<IFastBuyPackageList> {
  public constructor(sellerId: string | null = null, buyerId: string | null = null, hasLoans: boolean | null = null, status: string = 'Bid|Won|Lost|Indication|Funded|Pending Settle|Passed', selectedPackageId: string | null = null) {
    super('/datasource/packages', { sellerId, buyerId, hasLoans, status, selectedPackageId }, 250);
  }
}

export class PackageBasicDataSource extends PageListCachedDataSource<IEntityData> {
  public constructor(id: number | null = null, name: string | null = null, type: string | null = null, status: string | null = null) {
    super('/datasource/packagesbasic', { id, name, type, status }, Number.MAX_SAFE_INTEGER);
  }
}

export class BuyPackageBasicDataSource extends PageListCachedDataSource<IEntityData> {
  public constructor(id: number | null = null, name: string | null = null, type: string | null = null, status: string | null = null) {
    super('/datasource/buypackagesbasic', { id, name, type, status }, Number.MAX_SAFE_INTEGER);

  }
}